import * as Configuration from '../../../app.constants.js';

AddAccountFbController.$inject = ['$scope', '$http', 'TopToolbarFactory', '$stateParams', 'company', 'AlertingFactory', '$state', '$mdDialog', '$translate', 'FacebookSdk'];
export function AddAccountFbController($scope, $http, TopToolbarFactory, $stateParams, company, AlertingFactory, $state, $mdDialog, $translate, FacebookSdk) {
  let sites = [];
  let pages = [];
  let currentPage = 0;
  init();

  function checkScopes(requested, granted) {
    let grantedScopes = new Set(granted.split(","));
    for (let requestedScope of requested) {
      if (!grantedScopes.has(requestedScope)) {
        return false;
      }
    }
    return true;
  }

  function createSite(type, authorization_id) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + company.id + '/sites';
    return $http.post(url, {authorization_id: authorization_id, type: type});
  }

  function listPages(access_token, asset_scopes) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + company.id + '/fb/pages';
    return $http.post(url, {access_token : access_token, asset_scopes : asset_scopes});
  }

  function alertFailed(reason) {
    $scope.isLoading = false;
    let success = $mdDialog.alert()
      .title($translate.instant("add-account-fb/failed/title"))
      .textContent($translate.instant(reason))
      .ok($translate.instant("add-account-fb/failed/ok"))
      ;
    $mdDialog.show(success).finally(() => {
      $state.go("auth.alcmeon.parameters.add-account")
    });
  }

  function alertPartialFailure(page, reason) {
    $scope.isLoading = false;
    let content = $translate.instant("add-account-fb/partial-failed/content/begin") + 
      sites.length + 
      $translate.instant("add-account-fb/partial-failed/content/middle") + 
      page.name +
      $translate.instant("add-account-fb/partial-failed/content/end") +
      $translate.instant(reason);
    let success = $mdDialog.alert()
      .title($translate.instant("add-account-fb/partial-failed/title"))
      .textContent(content)
      .ok($translate.instant("add-account-fb/partial-failed/ok"))
      ;
    $mdDialog.show(success).finally(() => {
      // XXX: restart auth from start.
    });
  }

  function alertSuccess() {
    $scope.isLoading = false;
    if (sites.length > 1) {
      let success = $mdDialog.alert()
        .title($translate.instant("add-account-fb/multi-success/title"))
        .textContent($translate.instant("add-account-fb/multi-success/content/begin") + " " + sites.length + " " + $translate.instant("add-account-fb/multi-success/content/end") )
        .ok($translate.instant("add-account-fb/multi-success/ok/begin") + sites[0].name + $translate.instant("add-account-fb/multi-success/ok/end"))
        ;
      $mdDialog.show(success).finally(() => {
        $state.go("auth.alcmeon.fuse.preferences.account", {siteId: sites[0].id});
      });
    } else {
      let success = $mdDialog.alert()
        .title($translate.instant("add-account-fb/success/title"))
        .textContent($translate.instant("add-account-fb/success/content/begin") + sites[0].name + $translate.instant("add-account-fb/success/content/end") )
        .ok($translate.instant("add-account-fb/success/ok"))
        ;
      $mdDialog.show(success).finally(() => {
        $state.go("auth.alcmeon.fuse.preferences.account", {siteId: sites[0].id});
      });
    }
  }

  function createNextSite() {
    if (currentPage === pages.length) {
      alertSuccess();
      return;
    }
    let page = pages[currentPage];
    createSite("facebook", page.authorization_id).then(response => {
      sites.push(response.data);
      currentPage += 1;
      createNextSite();
    }, response => {
      if (sites.length === 0) {
        alertFailure(response.data.error);
      } else {
        alertPartialFailure(response.data.error);
      }
    });
  }

  function handleLoginResponse(accessToken, assetScopes) {
    listPages(accessToken, assetScopes).then(response => {
      if (response.data.pages.length === 0) {
        alertFailed("add-account/error/facebook/you-did-not-allow-any-page");
        return;
      }
      pages = response.data.pages.filter(p => p.can_be_authorized);
      if (pages.length === 0) {
        alertFailed("add-account/error/facebook/all-pages-already-managed");
        return;
      }
      createNextSite()
    }, response => {
      if (response.status === 400) {
        alertFailed(response.data.error);
      } else {
        alertFailed("add-account-fb/error/unexpected-1");
      }
    });
  }
  function connect() {
    let requestedScopes = ["manage_pages", "publish_pages", "read_insights"];
    let requestedAssetScopes = ["pages_messaging", "read_page_mailboxes"];
    FB.login((response) => {
      if (response.authResponse) {
        if (!checkScopes(requestedScopes, response.authResponse.grantedScopes)) {
          alertFailed("add-account-fb/error/missing-requested-scope");
          return;
        }
        handleLoginResponse(response.authResponse.accessToken, response.authResponse.asset_scopes);
      } else {
        AlertFailed("add-account-fb/error/authorization-canceled");
      }
    }, {
      scope: requestedScopes.join(","),
      asset_scope: requestedAssetScopes.join(","),
      enable_profile_selector : true,
      return_scopes: true
    });
  }

  function init() {
    $scope.isLoading = true;
    TopToolbarFactory.setTitleTranslation("add-account-fb/connect-page/title", $scope);
    connect();
  }
}
